import { inject } from 'dependable-react';

import { DEAPIFY_TOKEN } from './InjectTokens';

export class ApiClient {
  private deapify = inject(DEAPIFY_TOKEN);

  public async get(url: string) {
    return fetch(url, {
      credentials: 'include',
      method: 'GET',
    })
    .then(async (res) => res.json())
    .then(this.deapify);
  }

  public async patch(url: string, data: any) {
    return fetch(url, {
      body: data,
      credentials: 'include',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'PATCH',
    })
      .then(async (res) => res.json())
      .then(this.deapify);
  }

  public async post(url: string, data: any) {
    return fetch(url, {
      body: data,
      credentials: 'include',
      method: 'POST',
    })
      .then(async (res) => res.json())
      .then(this.deapify);
  }

  public async delayedGet(url: string, delay: number) {
    const startTime = Date.now();

    return this.get(url).then(
      async (res) =>
        new Promise((resolve) => {
          const endTime = Date.now();
          const tor = endTime - startTime;

          if (tor <= delay) {
            setTimeout(() => resolve(res), delay - tor);
          } else {
            resolve(res);
          }
        }),
    );
  }
}
